import { render, staticRenderFns } from "./RenderAiChat.vue?vue&type=template&id=7159c194"
import script from "./RenderAiChat.vue?vue&type=script&lang=js"
export * from "./RenderAiChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports